import React from "react";
import { useTranslation } from "react-i18next";
import * as styles from "./floor-detail-reposition-image.module.scss";
import PinnedList from "../pinned-list";
import PinnedListHeader from "../pinned-list-header";
import FloorInputPlaceImage from "../floor-input/floor-input-place-image";
import VelavuButton from "../../../../elements/velavu-button";
import { FloorEditState } from "../../../../state/floor/floor-edit-state";
import { classArr } from "../../../../helper/style-helper";

export interface FloorDetailRepositionImageProps {
	state: FloorEditState;
}

export default function FloorDetailRepositionImage(
	props: FloorDetailRepositionImageProps,
) {
	const { t } = useTranslation();

	return (
		<PinnedList>
			<PinnedListHeader
				label={t("dashboard.floor_create.place_floor_plan")}
				onClose={props.state.close}
			/>

			<FloorInputPlaceImage
				className={styles.content}
				imageOpacity={props.state.opacity}
				onChangeImageOpacity={props.state.setOpacity}
				availableFloors={props.state.referenceFloors}
				referenceFloorID={props.state.referenceFloorID}
				onSelectReferenceFloor={props.state.setReferenceFloorID}
			/>

			<div className={classArr(styles.content, styles.buttonRow)}>
				<VelavuButton
					label={t("common.cancel")}
					onClick={props.state.abandonPositioning}
					variant="outlined"
					fullWidth
				/>

				<VelavuButton
					label={t("common.confirm")}
					onClick={props.state.finishPositioning}
					fullWidth
				/>
			</div>
		</PinnedList>
	);
}
